import API from './API';

class CounterpartyAddressAPI extends API {
  constructor(parameters = {}) {
    super('/CounterpartyAddress', parameters);
  }

  getAllAddressTypes() {
    return this.submit('get', `${this.endpoint}/AddressTypes`);
  }
}

export default CounterpartyAddressAPI;
